
import {
  defineComponent, reactive, watch,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import { IColumn, ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import Icone from '@/core/components/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import Card from '@/core/components/Tela/Card.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { IProdutoKitItem } from '@/models/Entidades/Cadastros/Produtos/IProduto';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IDTOMontagemDesmontagemKit } from '@/models/DTO/Cadastros/Produtos/IDTOMontagemDesmontagemKit';
import SelecionarEstoque from '@/components/Cadastros/Estoques/SelecionarEstoque.vue';
import ServicoEstoque from '@/servicos/Cadastros/Estoques/ServicoEstoque';
import { IDTOEstoqueProdutoDefinicao } from '@/models/DTO/Cadastros/Estoques/IDTOEstoqueProdutoDefinicao';
import { IKitProdutos } from '@/models/Entidades/Cadastros/Produtos/IKitProdutos';
import KitsModal from './KitsModal.vue';
import ServicoKitProdutos from '@/servicos/Cadastros/Produtos/ServicoKitProdutos';

export default defineComponent({
  name: 'KitsProdutosModal',
  props: {
    visivel: {
      type: Boolean,
      default: false,
    },
    empresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Icone,
    RequisicaoModal,
    SelecionarProduto,
    CampoNumerico,
    Card,
    MensagemSemDados,
    SelecionarEstoque,
    KitsModal,
  },
  emits: ['update:visivel', 'confirmacao'],
  setup(props, { emit }) {
    const {
      telaBase, apresentarMensagemAlerta, apresentarMensagemSucesso, apresentarMensagemErro,
    } = useTelaBase();
    const { modalBase, apresentarBarraProgresso, ocultarBarraProgresso } = useModalBase(props, emit);
    const { gradeBase } = useGradeBase();
    const servicoProduto = new ServicoProduto();
    const servicoEstoque = new ServicoEstoque();
    const servicoKitProdutos = new ServicoKitProdutos();
    servicoProduto.requisicaoSistema();
    servicoEstoque.requisicaoSistema();
    servicoKitProdutos.requisicaoSistema();

    const state = reactive({
      colunasMontagem: [] as IColumn[],
      colunasDesmontagem: [] as IColumn[],
      colunasKits: [] as IColumn[],
      itensMontagem: [] as IProdutoKitItem[],
      itensDesmontagem: [] as IProdutoKitItem[],
      kits: [] as IKitProdutos[],
      estoquesDisponiveis: [] as IDTOEstoqueProdutoDefinicao[],
      abaSelecionada: 1,
      produtoSelecionadoMontagem: 0,
      produtoSelecionadoDesmontagem: 0,
      estoqueSelecionadoMontagem: 0,
      estoqueSelecionadoDesmontagem: 0,
      qtdMontagem: 0,
      qtdDesmontagem: 0,
      qtdDisponivel: 0,
      kitSelecionado: 0,
      exibirModalKit: false,
    });

    function preencherColunas() {
      state.colunasMontagem = [
        {
          title: 'Produto', dataIndex: 'descricaoProduto', key: 'DescricaoProduto', position: 1, visible: true,
        },
        {
          title: 'Unidade', dataIndex: 'descricaoUnidade', key: 'DescricaoUnidade', position: 2, visible: true, width: 100, align: 'center',
        },
        {
          title: 'Qtd Disponível', dataIndex: 'quantidadeEstoque', key: 'QtdDisponivel', position: 3, visible: true, width: 120, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right',
        },
        {
          title: 'Qtd no Kit', dataIndex: 'quantidade', key: 'QtdKit', position: 4, visible: true, width: 120, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right',
        },
        {
          title: 'Qtd Necessária', dataIndex: 'quantidadeMovimento', key: 'QtdMovimento', position: 5, visible: true, width: 120, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right',
        },
      ];
      state.colunasDesmontagem = [
        {
          title: 'Produto', dataIndex: 'descricaoProduto', key: 'DescricaoProduto', position: 1, visible: true,
        },
        {
          title: 'Unidade', dataIndex: 'descricaoUnidade', key: 'DescricaoUnidade', position: 2, visible: true, width: 100, align: 'center',
        },
        {
          title: 'Estoque Atual', dataIndex: 'quantidadeEstoque', key: 'QtdDisponivel', position: 3, visible: true, width: 120, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right',
        },
        {
          title: 'Qtd no Kit', dataIndex: 'quantidade', key: 'QtdKit', position: 4, visible: true, width: 120, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right',
        },
        {
          title: 'Qtd Retornada', dataIndex: 'quantidadeMovimento', key: 'QtdMovimento', position: 5, visible: true, width: 120, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right',
        },
      ];
      state.colunasKits = [
        {
          title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 1, visible: true,
        },
        {
          title: 'Qtd Itens', dataIndex: 'qtdItens', key: 'QtdItens', position: 2, visible: true, width: 120, align: 'right',
        },
        {
          title: 'Ações', key: 'acoes', position: 3, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
        },
      ];
    }

    function limparTela() {
      state.itensMontagem = [] as IProdutoKitItem[];
      state.itensDesmontagem = [] as IProdutoKitItem[];
      state.abaSelecionada = 1;
      state.produtoSelecionadoMontagem = 0;
      state.produtoSelecionadoDesmontagem = 0;
      state.estoqueSelecionadoMontagem = 0;
      state.estoqueSelecionadoDesmontagem = 0;
      state.qtdMontagem = 0;
      state.qtdDesmontagem = 0;
      state.qtdDisponivel = 0;
      preencherColunas();
    }

    function calcularQtdMovimento(montagem: boolean) {
      if (montagem) {
        state.itensMontagem.forEach((i, index) => {
          state.itensMontagem[index].quantidadeMovimento = state.itensMontagem[index].quantidade * state.qtdMontagem;
        });
      } else {
        state.itensDesmontagem.forEach((i, index) => {
          state.itensDesmontagem[index].quantidadeMovimento = state.itensDesmontagem[index].quantidade * state.qtdDesmontagem;
        });
      }
    }

    function obterQtdDisponivel() {
      state.qtdDisponivel = 0;
      if (state.estoquesDisponiveis.length > 0) {
        state.estoquesDisponiveis.forEach((e) => {
          if (e.codigoEstoque === state.estoqueSelecionadoDesmontagem) {
            state.qtdDisponivel = e.qtdDisponivel;
          }
        });
      }
    }

    async function obterEstoquesDisponiveis() {
      const produto = await servicoProduto.obter(state.produtoSelecionadoDesmontagem, props.empresa);
      state.estoquesDisponiveis = await servicoEstoque.obterEstoquesDefinicaoProduto(produto.definicoes[0].codigo, props.empresa);
      obterQtdDisponivel();
    }

    async function obterItensKit() {
      if (state.abaSelecionada === 1) {
        state.itensMontagem = await servicoProduto.obterItensKit(state.produtoSelecionadoMontagem);
        calcularQtdMovimento(true);
      } else {
        state.itensDesmontagem = await servicoProduto.obterItensKit(state.produtoSelecionadoDesmontagem);
        calcularQtdMovimento(false);
        obterEstoquesDisponiveis();
      }
    }

    function validarMontagem() {
      if (state.qtdMontagem <= 0) {
        apresentarMensagemAlerta('Informe a quantidade do kit!');
        return false;
      }

      if (state.itensMontagem.length <= 0) {
        apresentarMensagemAlerta('Nenhum item no kit!');
        return false;
      }

      let retorno = true;
      state.itensMontagem.forEach((i) => {
        if (!retorno) {
          if (i.quantidadeMovimento > i.quantidadeEstoque) {
            apresentarMensagemAlerta(`Quantidade do item ${i.descricaoProduto} maior que a disponível no estoque!`);
            retorno = false;
          }
        }
      });

      return true;
    }

    function validarDesmontagem() {
      if (state.qtdDesmontagem <= 0) {
        apresentarMensagemAlerta('Informe a quantidade do kit!');
        return false;
      }

      if (state.itensDesmontagem.length <= 0) {
        apresentarMensagemAlerta('Nenhum item no kit!');
        return false;
      }

      return true;
    }

    async function montarKits() {
      if (!validarMontagem()) {
        return;
      }

      apresentarBarraProgresso('Montando kits...');
      const montagem = {} as IDTOMontagemDesmontagemKit;
      montagem.produto = state.produtoSelecionadoMontagem;
      montagem.estoque = state.estoqueSelecionadoMontagem;
      montagem.empresa = props.empresa;
      montagem.quantidade = state.qtdMontagem;
      montagem.itens = state.itensMontagem;
      const retorno = await servicoProduto.montarKits(montagem);
      ocultarBarraProgresso();
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso('Kits montados com sucesso.');
        state.produtoSelecionadoMontagem = 0;
        state.qtdMontagem = 0;
        state.itensMontagem = [] as IProdutoKitItem[];
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
    }

    async function desmontarKits() {
      if (!validarDesmontagem()) {
        return;
      }

      apresentarBarraProgresso('Desmontando kits...');
      const desmontagem = {} as IDTOMontagemDesmontagemKit;
      desmontagem.produto = state.produtoSelecionadoDesmontagem;
      desmontagem.estoque = state.estoqueSelecionadoDesmontagem;
      desmontagem.empresa = props.empresa;
      desmontagem.quantidade = state.qtdDesmontagem;
      desmontagem.itens = state.itensDesmontagem;
      const retorno = await servicoProduto.desmontarKits(desmontagem);
      ocultarBarraProgresso();
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso('Kits desmontados com sucesso.');
        state.produtoSelecionadoDesmontagem = 0;
        state.qtdDesmontagem = 0;
        state.itensDesmontagem = [] as IProdutoKitItem[];
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
    }

    async function criarKit() {
      state.kitSelecionado = 0;
      state.exibirModalKit = true;
    }

    function editarKit(codigo: number) {
      state.kitSelecionado = codigo;
      state.exibirModalKit = true;
    }

    async function excluirKit(objeto: any) {
      Modal.confirm({
        title: 'Realmente deseja excluir o kit selecionado?',
        content: `Kit ${objeto.descricao} ?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoKitProdutos.excluirKit(objeto.codigo, props.empresa);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            apresentarMensagemSucesso('Kit excluído com sucesso.');
            state.kits = await servicoKitProdutos.obterTodos(props.empresa);
          } else {
            apresentarMensagemErro(retorno.mensagem);
          }
        },
      });
    }

    async function obterKits() {
      state.kits = await servicoKitProdutos.obterTodos(props.empresa);
    }

    watch(async () => modalBase.computedVisivel, async () => {
      limparTela();
      telaBase.carregando = true;
      if (modalBase.computedVisivel) {
        obterKits();
      }
      telaBase.carregando = false;
    });

    return {
      props,
      state,
      emit,
      telaBase,
      modalBase,
      gradeBase,
      storeSistema,
      UtilitarioData,
      UtilitarioMascara,
      UtilitarioGeral,
      ECustomRenderRow,
      obterItensKit,
      obterQtdDisponivel,
      calcularQtdMovimento,
      montarKits,
      desmontarKits,
      criarKit,
      editarKit,
      excluirKit,
      obterKits,
    };
  },
});
